import React from 'react';
import classNames from 'classnames/bind';
import * as styles from './ChallengeHeader.css';

const cx = classNames.bind(styles);

const ChallengeHeader = () => (
    <div className={cx('headingStages')}>
        <p className={cx('sectionTitle')}>Challenges</p>
        <span className={cx('stages')}>
            Accept Challenge <span className={cx('stagesDot')}>·</span> Start Shopping{' '}
            <span className={cx('stagesDot')}>·</span> Earn Rewards
        </span>
    </div>
);

export default ChallengeHeader;
